import React from "react";
import PropTypes from "prop-types";
//Material imports
import List from "@mui/material/List";
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { withi18n } from "@limitless/customer/components";
import { LinearProgress } from "@limitless/portal";
import { ExpertTaskList } from "@limitless/expert";
import TaskListItem from "./task-list-item/TaskListItem";
import TaskListHeader from "./task-list-header/TaskListHeader";

const TaskList = ({ classes, t }) => {
    const handleSelectMessage = (selectMessage, message, conversationError, onSelectMessage) => {
        selectMessage(message);
        //if the parent has an error, clear it on message select
        if (conversationError) {
            onSelectMessage();
        }
    };

    return (
        <ExpertTaskList>
            {({
                loading,
                hasMessages,
                newMessageLoading,
                selectedMessageId,
                removeTasklistRecord,
                onSelectMessage,
                onTaskListRefresh,
                messages,
                activeFilterCount
            }) => {
                return (
                    <List
                        className={classes.container}
                        subheader={
                            <TaskListHeader refreshHandler={onTaskListRefresh} activeFilterCount={activeFilterCount} />
                        }
                        component="div"
                    >
                        {loading && (
                            <div className={`${classes.noMessageDiv} msgBlinkAni`}>
                                <Typography color="textPrimary" id="fetchingTasks">
                                    {" "}
                                    {t("Fetching tasks...")}{" "}
                                </Typography>
                            </div>
                        )}
                        {!loading && !hasMessages && (
                            <div className={classes.noMessageDiv}>
                                <Typography color="textPrimary"> {t("No tasks available")} </Typography>
                            </div>
                        )}
                        {!loading &&
                            hasMessages &&
                            Object.keys(messages).map((messageKey, index) => {
                                const message = messages[messageKey];

                                return (
                                    <div
                                        style={{ position: "relative" }}
                                        key={message.messageId}
                                        onClick={() => handleSelectMessage(onSelectMessage, message)}
                                    >
                                        <TaskListItem
                                            message={message}
                                            delay={(index + 1) * 80}
                                            selected={selectedMessageId === message.messageId}
                                            onRemoveTask={removeTasklistRecord}
                                        />
                                        {newMessageLoading && selectedMessageId === message.messageId && (
                                            <LinearProgress />
                                        )}
                                    </div>
                                );
                            })}
                    </List>
                );
            }}
        </ExpertTaskList>
    );
};

const styles = theme => ({
    container: {
        position: "relative",
        width: 422,
        justifyContent: "flex-start",
        minWidth: 450,
        overflowY: "auto",
        overflowX: "hidden",
        boxShadow: theme.palette.rightBoxShadow,
        backgroundColor: theme.background.paper,
        marginRight: 2
    },
    noMessageDiv: {
        height: "calc(100% - 67px)",
        width: "100%",
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
});

export default withStyles(styles)(withi18n(TaskList));

TaskList.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    conversationError: PropTypes.bool.isRequired,
    onSelectMessage: PropTypes.func.isRequired
};
